import LearningMilestoneList from "./LearningMilestoneList";

export default LearningMilestoneList;
